// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-panel[data-v-5c8b7a3c] {\n    margin: 0 5px 10px 5px;\n    padding: 10px;\n    line-height: 40px;\n}\na[data-v-5c8b7a3c], .q-link[data-v-5c8b7a3c] {\n    text-decoration: none;\n    color: #0000009e;\n}\n", ""]);
// Exports
module.exports = exports;
